import { gql } from '@apollo/client';

export const INSTRUMENT_TEACHERS_QUERY = gql`
  query InstrumentTeachers($id: uuid!, $limit: Int!, $offset: Int!) {
    instruments_by_pk(id: $id) {
      id
      teacher_instruments(limit: $limit, offset: $offset) {
        user {
          id
          gdpr_name
        }
      }
      teacher_instruments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;
